import  React from 'react';
import "./NotFound.css";

export default function NotFound() {
    return <div className='PageError'>
      <p>Page Not Found :(</p>
      <img src="https://w0.peakpx.com/wallpaper/939/963/HD-wallpaper-technology-error-404-not-found-black-white-minimalist.jpg" alt="Error" />
      </div>;
  }
  